import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTankConicalRoofAndBottom = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 101,
	height: 150,
	viewBox: "0 0 101.0 150.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 1.0 30.0 L 51.0 0.0 L 101.0 30.0 L 101.0 120.0 L 51.0 150.0 L 1.0 120.0 Z M 1.0 120.0 L 101.0 120.0 M 1.0 30.0 L 101.0 30.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgTankConicalRoofAndBottom;
